'use strict';

import angular from 'angular';
import FormController from 'app/controllers/form';

class PendingSpendingController extends FormController {
    /* @ngInject */
    constructor(
        PendingSpendingsService,
        VouchersService,
        $scope,
        $mdDialog,
        $mdToast,
        $state,
        $location
    ) {
        let pendingSpending = $scope.$parent.$resolve.pendingSpending;
        super(
            pendingSpending,
            'Vale pendiente',
            PendingSpendingsService,
            null,
            'pending-spendings'
        );
        this.user = $scope.$parent.$resolve.user;

        Object.assign(this, {
            PendingSpendingsService,
            VouchersService,
            $mdDialog,
            $mdToast,
            $state,
            $location
        });
        this.btnEnabled = true;

        if (this.model.id) {
            this.neverEditable = true;
            this.availableVouchers = [this.model.srcVoucher];
            this.srcVoucher = this.model.srcVoucher;
        } else {
            //
        }
    }

    $onInit() {
        super.$onInit();
    }

    getVouchers() {
        return this.VouchersService.find({
            filter: {
                remainingAmount: {
                    gt: 0
                }
            }
        }).then(vouchers => {
            this.availableVouchers = vouchers;
        });
    }

    afterFirstSave() {
        this.neverEditable = true;
        this.srcVoucher.remainingAmount -= this.model.amount;
    }

    onSrcVoucherChange() {
        this.model.srcVoucher = this.srcVoucher;
    }

    updateAmount() {
        //console.debug(this.form.amount.$error);
    }

    void(ev) {
        var confirm = this.$mdDialog.prompt()
            .title('Anulación de Vale pendiente')
            .textContent(`Esto quitará el pendiente de todo Vale relacionado`)
            .placeholder('Motivo de anulación')
            .ariaLabel('Motivo de anulación')
            .required(true)
            .targetEvent(ev)
            .ok('Anular el pendiente')
            .cancel('Cancelar');

        this.$mdDialog.show(confirm).then(result => {
            this.showVoidSpin = true;
            this.PendingSpendingsService.void({
                id: this.model.id,
                reason: result
            }).then(() => {
                this.showVoidSpin = false;
                this.model.deletionReason = result;
                this.model.deletedAt = new Date();
            });
        });
    }
}

export default PendingSpendingController;
